import * as RT from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import s from "./Tooltip.module.css";
import { Kbd } from "./Kbd";

export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <RT.Provider delayDuration={450} skipDelayDuration={200}>
      {children}
    </RT.Provider>
  );
}

export function Tooltip({
  label,
  kbd,
  side = "bottom",
  children,
}: {
  label: string;
  kbd?: string;
  side?: "top" | "right" | "bottom" | "left";
  children: ReactNode;
}) {
  return (
    <RT.Root>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content className={s.content} side={side} sideOffset={6} collisionPadding={8}>
          {label}
          {kbd ? <Kbd combo={kbd} /> : null}
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
